<template>
  <div>
    <figure class="captioned-image" @click="openModal">
      <img v-lazy="getImg()" :alt="image.name" />
      <figcaption v-if="image.caption != null">
        {{ image.caption }}
      </figcaption>
    </figure>
    <b-modal v-model="imageClicked">
      <img :src="getImg()" :alt="image.name" />
      <p v-if="image.caption != null" class="center-text">
        {{ image.caption }}
      </p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ImageComponent",
  data() {
    return {
      imageClicked: false
    };
  },
  props: {
    // Takes the relevant info about images, with a path relative to the site number
    // Along with captions if relevant: {name: "img", path: "/path/img.png", caption?: "img"}
    image: {
      type: Object
    }
  },
  computed: {
    selected() {
      return this.$store.state.selected;
    }
  },
  methods: {
    getImg() {
      return require(`@/assets/sites/${this.selected}/${this.image.path}`);
    },
    openModal() {
      this.imageClicked = !this.imageClicked;
    }
  }
};
</script>

<style lang="scss" scoped>
.captioned-image {
  display: flex;
  flex-flow: column;
  width: 100%;

  img {
    width: auto;
    height: 30vh;
    object-fit: contain;
  }

  figcaption {
    background-color: #222;
    color: #fff;
    font-size: smaller;
    font-style: italic;
    padding: 0.25rem;
    text-align: center;
    width: 100%;
  }
}

img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}

.center-text {
  text-align: center;
  margin-top: 1%;
}
</style>
